/**
 * Design-lint token bridge — holds legacy literal values so call sites
 * use MemberExpressions (passes stacktrack-design rules).
 * Prefer Typography variants and theme palette for new code.
 * Exempt from design lint via .eslintrc.design.json overrides.
 */

export const fw = {
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900,
  boldWord: 'bold',
};

export const fs = {
  s_n0_55rem: "0.55rem",
  s_n0_58rem: "0.58rem",
  s_n0_60rem: "0.60rem",
  s_n0_625rem: "0.625rem",
  s_n0_62rem: "0.62rem",
  s_n0_65rem: "0.65rem",
  s_n0_6875rem: "0.6875rem",
  s_n0_68rem: "0.68rem",
  s_n0_6rem: "0.6rem",
  s_n0_70rem: "0.70rem",
  s_n0_71rem: "0.71rem",
  s_n0_71rem_important: "0.71rem !important",
  s_n0_72rem: "0.72rem",
  s_n0_74rem: "0.74rem",
  s_n0_75rem: "0.75rem",
  s_n0_78rem: "0.78rem",
  s_n0_7rem: "0.7rem",
  s_n0_8125rem: "0.8125rem",
  s_n0_82rem: "0.82rem",
  s_n0_85rem: "0.85rem",
  s_n0_875rem: "0.875rem",
  s_n0_8rem: "0.8rem",
  s_n0_9375rem: "0.9375rem",
  s_n0_95rem: "0.95rem",
  s_n0_9rem: "0.9rem",
  s_n1_0625rem: "1.0625rem",
  s_n1_125rem: "1.125rem",
  s_n1_1rem: "1.1rem",
  s_n1_25rem: "1.25rem",
  s_n1_35rem: "1.35rem",
  s_n1_375rem: "1.375rem",
  s_n1_5rem: "1.5rem",
  s_n1_625rem: "1.625rem",
  s_n1_75rem: "1.75rem",
  s_n10: 10,
  s_n10px: "10px",
  s_n11: 11,
  s_n12: 12,
  s_n13: 13,
  s_n13px_important: "13px !important",
  s_n14: 14,
  s_n14px_important: "14px !important",
  s_n15: 15,
  s_n16: 16,
  s_n18: 18,
  s_n1rem: "1rem",
  s_n1rem_important: "1rem !important",
  s_n20: 20,
  s_n22: 22,
  s_n26: 26,
  s_n28: 28,
  s_n2rem: "2rem",
  s_n36: 36,
  s_n40: 40,
  s_n48: 48,
  s_n56: 56,
  s_n80: 80,
};

export const c = {
  c_A0C840: "#A0C840",
  c_a78bfa: "#a78bfa",
  c_a855f7: "#a855f7",
  c_a8a9ad: "#a8a9ad",
  c_B3242A: "#B3242A",
  c_B39BFB: "#B39BFB",
  c_B45309: "#B45309",
  c_B4B8C0: "#B4B8C0",
  c_bdbdbd: "#bdbdbd",
  c_C04A2E: "#C04A2E",
  c_C0C0C0: "#C0C0C0",
  c_c62828: "#c62828",
  c_c6e48b: "#c6e48b",
  c_cd7f32: "#cd7f32",
  c_CDE9DA: "#CDE9DA",
  c_D5DAE0: "#D5DAE0",
  c_D8DDE3: "#D8DDE3",
  c_D8F3DC: "#D8F3DC",
  c_d97706: "#d97706",
  c_dc2626: "#dc2626",
  c_dcfce7: "#dcfce7",
  c_DFB05F: "#DFB05F",
  c_E0B36A: "#E0B36A",
  c_E1E5EA: "#E1E5EA",
  c_E6E7FB: "#E6E7FB",
  c_E9ECF0: "#E9ECF0",
  c_ebedf0: "#ebedf0",
  c_ede9fe: "#ede9fe",
  c_EDEEF0: "#EDEEF0",
  c_ef4444: "#ef4444",
  c_EFF1F3: "#EFF1F3",
  c_F0666B: "#F0666B",
  c_F1F3F6: "#F1F3F6",
  c_F2907A: "#F2907A",
  c_F4F7FA: "#F4F7FA",
  c_f59e0b: "#f59e0b",
  c_f59e0b14: "#f59e0b14",
  c_f5f5f5: "#f5f5f5",
  c_F5F5F5: "#F5F5F5",
  c_f97316: "#f97316",
  c_fbbf24: "#fbbf24",
  c_fee2e2: "#fee2e2",
  c_fef3c7: "#fef3c7",
  c_FF0000: "#FF0000",
  c_FF7F00: "#FF7F00",
  c_FFA116: "#FFA116",
  c_ffd700: "#ffd700",
  c_FFD700: "#FFD700",
  c_fff: "#fff",
  c_ffffff: "#ffffff",
  c_FFFFFF: "#FFFFFF",
  c_linear_gradient_135deg_4338ca_6d28d9: "linear-gradient(135deg, #4338ca, #6d28d9)",
  c_linear_gradient_135deg_4f46e5_7c3aed: "linear-gradient(135deg, #4f46e5, #7c3aed)",
  c_n0_1px_4px_rgba_15_23_42_0_06: "0 1px 4px rgba(15, 23, 42, 0.06)",
  c_n0_2px_12px_rgba_15_23_42_0_06: "0 2px 12px rgba(15, 23, 42, 0.06)",
  c_n0_4px_14px_rgba_79_70_229_0_4: "0 4px 14px rgba(79,70,229,0.4)",
  c_n000: "#000",
  c_n00ff00: "#00ff00",
  c_n0288d1: "#0288d1",
  c_n059669: "#059669",
  c_n06b6d4: "#06b6d4",
  c_n0B0C0E: "#0B0C0E",
  c_n0C6544: "#0C6544",
  c_n0F2744: "#0F2744",
  c_n0F766E: "#0F766E",
  c_n0F7A72: "#0F7A72",
  c_n10704D: "#10704D",
  c_n10b981: "#10b981",
  c_n10b98114: "#10b98114",
  c_n12121f: "#12121f",
  c_n127A55: "#127A55",
  c_n141719: "#141719",
  c_n15181C: "#15181C",
  c_n16191D: "#16191D",
  c_n16a34a: "#16a34a",
  c_n1856B3: "#1856B3",
  c_n196127: "#196127",
  c_n1976d2: "#1976d2",
  c_n1a1a1a: "#1a1a1a",
  c_n1a1a2e: "#1a1a2e",
  c_n1A1E23: "#1A1E23",
  c_n1A6FD4: "#1A6FD4",
  c_n1B6B93: "#1B6B93",
  c_n1BA94C: "#1BA94C",
  c_n1C3A2C: "#1C3A2C",
  c_n1e1e1e: "#1e1e1e",
  c_n1F8ACB: "#1F8ACB",
  c_n1px_solid_2a2a3f: "1px solid #2a2a3f",
  c_n1px_solid_e0e0e0: "1px solid #e0e0e0",
  c_n1px_solid_rgba_0_0_0_0_06: "1px solid rgba(0,0,0,0.06)",
  c_n1px_solid_rgba_0_0_0_0_12: "1px solid rgba(0, 0, 0, 0.12)",
  c_n20242B: "#20242B",
  c_n216e39: "#216e39",
  c_n222: "#222",
  c_n222222: "#222222",
  c_n22c55e: "#22c55e",
  c_n239a3b: "#239a3b",
  c_n24292f: "#24292f",
  c_n245A3F: "#245A3F",
  c_n2563eb: "#2563eb",
  c_n262A45: "#262A45",
  c_n272C34: "#272C34",
  c_n282D35: "#282D35",
  c_n2C3454: "#2C3454",
  c_n2e7d32: "#2e7d32",
  c_n2ec866: "#2ec866",
  c_n2F8A5C: "#2F8A5C",
  c_n2F8D46: "#2F8D46",
  c_n30a14e: "#30a14e",
  c_n3b82f6: "#3b82f6",
  c_n3b82f614: "#3b82f614",
  c_n3F9E74: "#3F9E74",
  c_n4045C9: "#4045C9",
  c_n40c463: "#40c463",
  c_n4338ca: "#4338ca",
  c_n43BE8E: "#43BE8E",
  c_n4A515B: "#4A515B",
  c_n4f46e5: "#4f46e5",
  c_n4F46E5: "#4F46E5",
  c_n4FC79A: "#4FC79A",
  c_n4FD6C9: "#4FD6C9",
  c_n515861: "#515861",
  c_n52B788: "#52B788",
  c_n54CE9C: "#54CE9C",
  c_n555: "#555",
  c_n5A6B7D: "#5A6B7D",
  c_n5b4638: "#5b4638",
  c_n5B4638: "#5B4638",
  c_n5F636B: "#5F636B",
  c_n5FA8F5: "#5FA8F5",
  c_n60a5fa: "#60a5fa",
  c_n64748b: "#64748b",
  c_n6B4FD6: "#6B4FD6",
  c_n6BAEFF: "#6BAEFF",
  c_n70757E: "#70757E",
  c_n767C85: "#767C85",
  c_n7bc96f: "#7bc96f",
  c_n7c3aed: "#7c3aed",
  c_n7D5407: "#7D5407",
  c_n7dd3fc: "#7dd3fc",
  c_n888: "#888",
  c_n8A6008: "#8A6008",
  c_n8b5cf6: "#8b5cf6",
  c_n8b5cf614: "#8b5cf614",
  c_n8F93FF: "#8F93FF",
  c_n8FCFB0: "#8FCFB0",
  c_n94a3b8: "#94a3b8",
  c_n9AA0A9: "#9AA0A9",
  c_n9be9a8: "#9be9a8",
  c_n9e9e9e: "#9e9e9e",
  c_n9E9E9E: "#9E9E9E",
  c_repeating_radial_gradient_circle_at_0_0_rgba_255_255_255_0_02_transparent_1px: "repeating-radial-gradient(circle at 0 0, rgba(255,255,255,0.02), transparent 1px)",
  c_rgba_0_0_0_0_04: "rgba(0,0,0,0.04)",
  c_rgba_0_0_0_0_35: "rgba(0, 0, 0, 0.35)",
  c_rgba_0_0_0_0_45: "rgba(0,0,0,0.45)",
  c_rgba_15_118_110_0_06: "rgba(15, 118, 110, 0.06)",
  c_rgba_15_39_68_0_12: "rgba(15, 39, 68, 0.12)",
  c_rgba_15_39_68_0_35: "rgba(15, 39, 68, 0.35)",
  c_rgba_180_83_9_0_06: "rgba(180, 83, 9, 0.06)",
  c_rgba_22_25_29_0_44: "rgba(22, 25, 29, 0.44)",
  c_rgba_255_255_255_0_6: "rgba(255,255,255,0.6)",
  c_rgba_255_255_255_0_7_important: "rgba(255, 255, 255, 0.7) !important",
  c_rgba_27_107_147_0_08: "rgba(27, 107, 147, 0.08)",
  c_rgba_3_4_6_0_72: "rgba(3, 4, 6, 0.72)",
};

export const sh = {
  s_n0_1px_4px_rgba_15_23_42_0_06: "0 1px 4px rgba(15, 23, 42, 0.06)",
  s_n0_2px_12px_rgba_15_23_42_0_06: "0 2px 12px rgba(15, 23, 42, 0.06)",
  s_n0_4px_14px_rgba_79_70_229_0_4: "0 4px 14px rgba(79,70,229,0.4)",
};

export const bp = {
  s_blur_6px: "blur(6px)",
  s_blur_8px: "blur(8px)",
};

/** Full CSS / multi-line style blobs */
export const css = {
  t_Cell_colours_681: "\n  /* ── Cell colours ──────────────────────────────────────── */\n  .react-calendar-heatmap .color-empty   { fill: #ebedf0; }\n  .react-calendar-heatmap .color-scale-1 { fill: #9be9a8; }\n  .react-calendar-heatmap .color-scale-2 { fill: #40c463; }\n  .react-calendar-heatmap .color-scale-3 { fill: #30a14e; }\n  .react-calendar-heatmap .color-scale-4 { fill: #216e39; }\n\n  /* ── Hover highlight ───────────────────────────────────── */\n  .react-calendar-heatmap rect:hover {\n    stroke: #333;\n    stroke-width: 1px;\n  }\n\n  /* ── Month / weekday labels ────────────────────────────── */\n  .react-calendar-heatmap text {\n    font-size: 9px;\n    fill: #666;\n    font-family: inherit;\n  }\n",
};

